export enum Accreditation {
    ACCREDITED_BY_VTB = 'ACCREDITED_BY_VTB'
}
